
import { Component, Vue, Watch } from "vue-property-decorator";
import WizardCart from "@/views/_components/WizardCart.vue";
import { namespace } from "vuex-class";
import CheckoutPersonalInfo from "@/views/_components/CheckoutPersonalInfo.vue";
import { Cart } from "@/types/Cart";
import StatusComponent from "@/components/StatusComponent.vue";
import Loader from "@/components/Loader.vue";
import IUser from "@/models/protocols/IUser";
import UserService from "@/services/UserService";
import ElementLoader from "@/components/ElementLoader.vue";
const { State, Action } = namespace("Root");
import ValidationMessage from "@/views/_components/ValidationMessage.vue";
import countryService from "@/services/CountryService";
// import ICountry from "@/models/protocols/ICountry";
import { Country } from "@/types/Country";
import supported_countries from "@/assets/supported_countries.json";
import NumericInput from "@/components/NumericInput.vue";
import RegionInput from "@/components/RegionInput.vue";
import User from "@/models/User";
import Address from "@/models/Address";
import IAddress from "@/models/protocols/IAddress";
import axios from "axios";
import { zipValidation } from "@/utils/zipValidation";
declare var google: any;

@Component({
  components: {
    WizardCart,
    CheckoutPersonalInfo,
    StatusComponent,
    Loader,
    ElementLoader,
    ValidationMessage,
    NumericInput,
    RegionInput,
  },
})
export default class WizardTwo extends Vue {
  vHtml(vHtml: any) {
    throw new Error("Method not implemented.");
  }

  @State("cart") cart!: Cart;
  @State("user") user!: IUser;
  @State("regions") regions!: Array<Country>;
  @Action setRegions;
  userLocal = new User();
  address = new Address();
  autocomplete: any = null;
  contunueHTML = "&nbsp;";
  create_account = true;
  loading = false;
  password = "";
  confirm_password = "";
  rtoken = "";
  timeout: any;
  button_loading = false;
  showErrorMsg = false;
  msg_list: any[] = [];

  componentForm = {
    subpremise: "short_name",
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    administrative_area_level_1: "short_name",
    country: "short_name",
    postal_code: "short_name",
    postal_town: "short_name",
    sublocality_level_1: "short_name",
  };

  constructor() {
    super();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  async mounted() {
    this.address = new Address();
    if (Object.keys(this.regions).length === 0) {
      const regions = await countryService.getRegions();
      this.setRegions(regions);
    }

    this.cart.clearIfCompleted();
    this.scrollToTop();
    if (this.cart.items.length == 0) {
      this.$router.push({ name: "home" });
    }
    this.loading = true;
    // Check if the user is logged in.
    if (await UserService.isLoggedIn()) {
      this.loading = false;
      this.$router.push({ name: "wizard.three" });
    }
    this.loading = false;
    this.cart.itemsChanged.on(this.onItemsChanged);

    if (typeof google === "undefined") {
      if (!process.env.VUE_APP_GOOGLE_API_KEY) {
        console.error("Google API key is not set.");
        return;
      }
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places`;
      script.onload = () => {
        this.initAutocomplate();
      };
      document.head.appendChild(script);
    } else {
      this.initAutocomplate();
    }
  }

  onItemsChanged() {
    if (this.cart.items.length == 0) {
      this.timeout = setTimeout(this.goHome, 5000);
    }
  }

  initAutocomplate() {
    if (typeof google === "undefined") {
      return;
    }
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocompleteAddress as HTMLInputElement,
      {
        types: ["geocode"],
        componentRestrictions: { country: ["CA", "US"] },
      }
    );
    this.autocomplete.addListener("place_changed", () => {
      this.getAddressData();
    });
  }

  getAddressData() {
    const place = this.autocomplete.getPlace();
    const addressComponents = place.address_components;

    let streetNumber = "";
    let subpremise = "";
    let city = "";
    let region = "";
    let postalCode = "";
    let countryId = "";
    let street: string[] = [];
    let formattedStreet = "";

    addressComponents.forEach((component) => {
      const addressType = component.types[0];
      if (this.componentForm[addressType]) {
        const val = component[this.componentForm[addressType]];
        if (addressType === "subpremise") {
          subpremise = val;
        } else if (addressType === "street_number") {
          streetNumber = val;
        } else if (addressType === "route") {
          street[1] = val;
        } else if (addressType === "locality") {
          city = val;
        } else if (addressType === "administrative_area_level_1") {
          region = val;
        } else if (addressType === "postal_code") {
          postalCode = val;
        } else if (addressType === "country") {
          countryId = val;
        }
      }
    });

    const regionObj = this.regions[countryId]
      ? this.regions[countryId].find((reg: Country) => reg.short === region)
      : null;

    const regionId = regionObj ? regionObj.id : 0;

    if (subpremise && countryId !== "US") {
      streetNumber = `${subpremise}/${streetNumber}`;
    }

    if (street.length > 0) {
      street[0] = streetNumber;
      formattedStreet = street.join(" ");
      if (countryId === "US" && subpremise !== "") {
        formattedStreet = `${formattedStreet}, ${subpremise}`;
      }
    }

    this.address.street = formattedStreet ? [formattedStreet] : [];
    this.address.city = city ? city : "";
    this.address.postcode = postalCode ? postalCode : "";
    this.address.countryId = countryId ? countryId : "";

    setTimeout(() => {
      this.address.region.regionId = regionId ? regionId : 0;
      this.address.region.regionCode = region ? region : "";
      this.address.region.region = regionObj ? regionObj.title : "";
    }, 500);
  }

  beforeDestroy() {
    this.cart.itemsChanged.off(this.onItemsChanged);
  }

  goHome() {
    clearTimeout(this.timeout);
    this.$router.push({ name: "home" });
  }

  /**
   * Gets status component
   */
  status() {
    if (this.create_account) {
      return this.$refs.status1 as any;
    } else {
      return this.$refs.status2 as any;
    }
  }

  removeFormErrors(target: string) {
    const statusComponent = this.status();
    statusComponent.clear();
  }

  @Watch("create_account")
  createAccountChanged() {
    this.userLocal.email = "";
    this.password = "";
    this.confirm_password = "";
  }

  async onSubmit() {
    this.generateErrMsg();
    // this.userLocal.addresses.push(this.address);
    if (this.validated) {
      this.showErrorMsg = false;
      this.status().clear();
      // Login existing account
      if (!this.create_account) {
        await this.loginUser(this.userLocal.email, this.password);
      } else {
        // Create new account, then login with it
        await this.createUser();
      }
      // this.$router.push({ name: "wizard.three" });
    } else {
      this.showErrorMsg = true;
    }
  }

  generateErrMsg() {
    this.msg_list = [];
    if (this.create_account) {
      if (
        this.userLocal.email == "" ||
        this.password == "" ||
        this.userLocal.firstName == "" ||
        this.userLocal.lastName == "" ||
        this.confirm_password == "" ||
        this.address.region.regionId == 0 ||
        this.address.countryId == "" ||
        this.address.city == "" ||
        this.address.postcode == "" ||
        this.address.telephone == "" ||
        this.address.street.length < 0 ||
        this.address.street[0] == ""
      ) {
        this.msg_list.push("Please fill in required fields.");
      }
      if (!this.validateEmail(this.userLocal.email)) {
        this.msg_list.push("Please insert valid email.");
      }
      if (!zipValidation(this.address.countryId, this.address.postcode)) {
        this.msg_list.push("Please insert valid postcode");
      }
      if (this.password.length < process.env.PASS_LEN) {
        this.msg_list.push(
          `Password needs at least ${process.env.PASS_LEN} characters.`
        );
      }
      if (this.password != this.confirm_password) {
        this.msg_list.push("Passwords don't match.");
      }
    } else if (!this.create_account) {
      if (this.userLocal.email == "" || this.password == "") {
        this.msg_list.push("Please fill in required fields.");
      }
      if (!this.validateEmail(this.userLocal.email)) {
        this.msg_list.push("Please insert valid email.");
      }
      if (this.password.length < process.env.PASS_LEN) {
        this.msg_list.push(
          `Password needs at least ${process.env.PASS_LEN} characters.`
        );
      }
    }
  }

  validateEmail(email: string) {
    let re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  async loginUser(email: string, password: string) {
    this.button_loading = true;
    try {
      if (await UserService.login(email, password)) {
        this.button_loading = false;
        // All good
        this.$router.push({ name: "wizard.three" });
      }
      this.button_loading = false;
    } catch (error) {
      this.button_loading = false;
      this.status().error_response(error);
      this.scrollToTop();
    }
  }

  async createUser() {
    await this.$recaptchaLoaded();
    // Execute reCAPTCHA with action "login".
    const rtoken = await this.$recaptcha("login");

    this.button_loading = true;
    try {
      //Store User With Address in Vuex
      // Object.assign(this.userLocal, this.user);
      this.userLocal.addresses = [this.address];
      await UserService.create(this.userLocal, this.password, rtoken);

      //Fill Address Fields: FirstName, LastName and Customer Id
      UserService.updateAddressFromUser(this.address, this.user);
      //Update Address On New Registered User in Magento
      const response = await UserService.updateUser(this.user);
      // UserService.storeUserInStore(this.userLocal);
      //Store Also Address in Billing Info
      this.button_loading = false;
      // All good
      this.$router.push({ name: "wizard.three" });
    } catch (error) {
      this.button_loading = false;
      this.status().error_response(error);
      this.scrollToTop();
    }
  }

  // get states(): ICountry[] {
  //   return CountryService.states();
  // }

  get validated() {
    let validate =
      this.userLocal.email != "" &&
      this.password.length >= process.env.PASS_LEN;
    validate = validate && this.validateEmail(this.userLocal.email);
    validate =
      validate && zipValidation(this.address.countryId, this.address.postcode);
    if (this.create_account) {
      validate =
        validate &&
        this.userLocal.firstName != "" &&
        this.userLocal.lastName != "" &&
        this.address.countryId != "" &&
        this.address.region.regionId != 0 &&
        this.address.city != "" &&
        this.address.postcode != "" &&
        this.address.telephone != "" &&
        this.confirm_password != "" &&
        this.password == this.confirm_password &&
        this.confirm_password.length >= process.env.PASS_LEN &&
        this.address.street.length > 0 &&
        this.address.street[0] != "";
    }
    return validate;
  }

  showValidationClass(value: string | number, mode = "default") {
    if (mode == "default") {
      return (value == "" || value == "0") && this.showErrorMsg;
    } else if (mode == "email" && typeof value == "string") {
      value = value.toString();
      return (
        (value == "" && this.showErrorMsg) ||
        (!this.validateEmail(value) && this.showErrorMsg)
      );
    } else if (mode == "postcode" && typeof value == "string") {
      value = value.toString();
      return (
        (value == "" && this.showErrorMsg) ||
        (!zipValidation(this.address.countryId, this.address.postcode) &&
          this.showErrorMsg)
      );
    } else if (mode == "password" && typeof value == "string") {
      value = value.toString();
      return (
        (value == "" && this.showErrorMsg) ||
        (value.length < process.env.PASS_LEN && this.showErrorMsg)
      );
    } else {
      return false;
    }
  }

  get supportedCountries() {
    return supported_countries;
  }

  countryChanged() {
    this.address.region.regionId = 0;
  }

  get regionsFromSelectedCountry() {
    if (this.regions[this.address.countryId]) {
      return this.regions[this.address.countryId];
    } else {
      return null;
    }
  }

  get isCanadaCountry() {
    return this.address.countryId === "CA";
  }

  get validationPassMsg() {
    return `Minimum ${process.env.PASS_LEN} characters`;
  }
}
